export default __webpack_public_path__ + "static/media/a011-startup-5.f295d60a.svg";